export default "__VITE_ASSET__DBzh2Z5F__"